import { writable } from 'svelte/store';
import axios from 'axios';
export const connected = writable(false);
export const currentUser = writable(null);
export const token = writable('');
token.subscribe((newValue) => {
    if (newValue && newValue !== '') {
        localStorage.setItem('session-token', newValue);
    }
});
token.subscribe((newValue) => {
    checkAuthentication(newValue);
});
export function checkAuthentication(bearer) {
    if (!bearer || bearer === '') {
        return;
    }
    axios.get('/umbraco/api/mynemi/isauthenticated', {
        headers: { Authorization: `Bearer ${bearer}` },
    })
        .then((user) => {
        connected.set(user.data !== null);
        currentUser.set(user.data);
    });
}
export function reloadToken() {
    const localToken = localStorage.getItem('session-token');
    if (localToken) {
        token.set(localToken);
    }
}
